import { imgUrl } from "@/lib/api";

export const CornerVine = ({ className = "", style }) => (
  <svg viewBox="0 0 100 100" className={className} style={style} aria-hidden="true">
    <path d="M4 98 V22 Q4 4 22 4 H98" stroke="#c9a227" strokeWidth="3" fill="none" />
    <path d="M11 98 V26 Q11 11 26 11 H98" stroke="#991b1b" strokeWidth="1.2" fill="none" />
    <circle cx="24" cy="24" r="11" stroke="#1e4976" strokeWidth="2.2" fill="none" />
    <circle cx="24" cy="24" r="11" stroke="#c9a227" strokeWidth="0.8" fill="none" strokeDasharray="3 3" />
    <circle cx="24" cy="24" r="4.5" fill="#c9a227" />
    <circle cx="24" cy="24" r="1.8" fill="#991b1b" />
    <path d="M24 35 C34 48 14 58 24 72 S32 88 24 98" stroke="#2f6b3a" strokeWidth="1.6" fill="none" />
    <path d="M35 24 C48 34 58 14 72 24 S88 32 98 24" stroke="#2f6b3a" strokeWidth="1.6" fill="none" />
    <ellipse cx="31" cy="52" rx="4" ry="2" fill="#2f6b3a" transform="rotate(-30 31 52)" />
    <ellipse cx="17" cy="78" rx="4" ry="2" fill="#2f6b3a" transform="rotate(35 17 78)" />
    <ellipse cx="52" cy="31" rx="4" ry="2" fill="#2f6b3a" transform="rotate(-60 52 31)" />
    <ellipse cx="78" cy="17" rx="4" ry="2" fill="#2f6b3a" transform="rotate(55 78 17)" />
    <circle cx="42" cy="42" r="2.4" fill="#ea580c" />
    <circle cx="62" cy="40" r="1.6" fill="#0284c7" />
    <circle cx="40" cy="62" r="1.6" fill="#0284c7" />
  </svg>
);

export const FrameCorners = ({ size = "w-14 h-14 sm:w-20 sm:h-20" }) => (
  <>
    <CornerVine className={`absolute -top-2 -left-2 pointer-events-none ${size}`} />
    <CornerVine className={`absolute -top-2 -right-2 pointer-events-none ${size}`} style={{ transform: "scaleX(-1)" }} />
    <CornerVine className={`absolute -bottom-2 -left-2 pointer-events-none ${size}`} style={{ transform: "scaleY(-1)" }} />
    <CornerVine className={`absolute -bottom-2 -right-2 pointer-events-none ${size}`} style={{ transform: "scale(-1,-1)" }} />
  </>
);

export const KnotDivider = ({ className = "" }) => (
  <div className={`flex items-center gap-3 ${className}`} aria-hidden="true">
    <span className="h-px flex-1 bg-gradient-to-r from-transparent via-[#1e4976]/60 to-[#c9a227]" />
    <svg viewBox="0 0 64 24" className="w-16 h-6 shrink-0">
      <circle cx="24" cy="12" r="9" stroke="#1e4976" strokeWidth="2.4" fill="none" />
      <circle cx="40" cy="12" r="9" stroke="#991b1b" strokeWidth="2.4" fill="none" />
      <circle cx="32" cy="12" r="3" fill="#c9a227" />
      <path d="M2 12 L10 8 L10 16 Z M62 12 L54 8 L54 16 Z" fill="#c9a227" />
    </svg>
    <span className="h-px flex-1 bg-gradient-to-r from-[#c9a227] via-[#991b1b]/60 to-transparent" />
  </div>
);

export const Monogram = () => (
  <svg viewBox="0 0 100 100" className="w-full h-full" aria-hidden="true">
    <rect width="100" height="100" fill="#1a120c" />
    <circle cx="50" cy="50" r="38" stroke="#c9a227" strokeWidth="3" fill="none" />
    <circle cx="50" cy="50" r="31" stroke="#1e4976" strokeWidth="1.5" fill="none" />
    <text x="50" y="62" textAnchor="middle" fontFamily="Uncial Antiqua, serif" fontSize="34" fill="#e6bb45">LE</text>
  </svg>
);

const LOGO_SIZES = { sm: "w-12 h-12 sm:w-14 sm:h-14", md: "w-24 h-24", lg: "w-36 h-36 sm:w-44 sm:h-44" };

export const SquareLogo = ({ src, size = "sm", testid = "header-square-logo" }) => (
  <div
    data-testid={testid}
    className={`${LOGO_SIZES[size]} aspect-square shrink-0 overflow-hidden bg-[#1a120c] border-2 border-[#c9a227] p-[3px] shadow-[0_0_14px_rgba(201,162,39,0.35)]`}
  >
    {src ? <img src={imgUrl(src)} alt="Imprint logo" className="w-full h-full object-cover" /> : <Monogram />}
  </div>
);
